import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=45458891&scoped=true&"
import script from "./ReportForm.vue?vue&type=script&lang=js&"
export * from "./ReportForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportForm.vue?vue&type=style&index=0&id=45458891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45458891",
  null
  
)

export default component.exports